import Components from "slotworks/components/components";
import AbstractMediator from "slotworks/mediators/abstract-mediator";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Contract from "slotworks/utils/contract";

export default class BetMenuFreespinsMediator extends AbstractMediator {

    public start(): Contract<any> {
        this.update();

        return super.start();
    }

    private update() {
        const game = GameState.getCurrentGame();
        const record = game.getCurrentRecord();

        // Deduct 1 so the remaining spins seems to deduct as we spin, not after the result comes in
        if (record instanceof FreespinRecord) {
            Components.betBar.setTotalFreespins(record.totalFreespins);
            Components.betBar.setRemainingFreespins(Math.max(0, record.remainingFreespins - 1));
        } else if ((record as SpinRecord).freespinsWon) {
            Components.betBar.setTotalFreespins((record as SpinRecord).freespinsWon);
            Components.betBar.setRemainingFreespins(Math.max(0, game.getTotalFreespinsWon() - 1));
        } else {
            let currentRecordIndex = game.getCurrentRecordIndex();
            while (currentRecordIndex > 1) {
                currentRecordIndex--;

                const previousRecord = game.getRecordAtIndex(currentRecordIndex);
                if (previousRecord instanceof FreespinRecord) {
                    Components.betBar.setTotalFreespins(previousRecord.totalFreespins);
                    Components.betBar.setRemainingFreespins(Math.max(0, previousRecord.remainingFreespins - 1));
                    break;
                }
            }
        }

        Components.betBar.setEnabled(false);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/mediators/bet-menu-freespins-mediator.ts